module.exports = __webpack_public_path__ + "static/media/cross-grey.6be5400c.svg";